<div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
  @for (item of menuItems; track item.link) {
    <button
      type="button"
      (click)="router.navigate([item.link])"
      [disabled]="item.disabled"
      class="group relative aspect-square rounded-2xl border border-slate-200/80 bg-white flex flex-col items-center justify-center gap-[14px] p-4 transition-all hover:border-[var(--primary-color)]/40 hover:shadow-[0_18px_36px_-22px_rgba(15,23,42,.25)] disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]/30"
    >
      @if (item.notificationsCount) {
        <span
          class="absolute top-[12px] right-[12px] min-w-[20px] h-5 px-1.5 rounded-full bg-[var(--app-theme-color)] text-white text-[14px] font-semibold flex items-center justify-center"
        >
          {{ item.notificationsCount }}
        </span>
      }

      <div
        class="w-14 h-14 rounded-2xl flex items-center justify-center bg-[color-mix(in_srgb,var(--primary-color),transparent_88%)] transition-transform group-hover:scale-105"
      >
        <app-custom-color-icon
          [svgPath]="item.imageLink"
          [color]="tenantPrimaryColor"
          [size]="28"
        />
      </div>
      <div class="relative w-full h-[14px]">
        <span
          style="transform: translateX(-50%)"
          class="absolute left-1/2 whitespace-nowrap text-[14px] font-semibold text-slate-900 leading-snug"
        >
          {{ item.name | transloco }}
        </span>
      </div>
    </button>
  }
</div>
